var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 4H10",
    stroke: "#1C738E",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 7H10",
    stroke: "#1C738E",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 10H6",
    stroke: "#1C738E",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 9V2C14 0.895431 13.1046 0 12 0H2C0.895431 0 0 0.895431 0 2V12L0.0107422 12.2041C0.1062 13.1457 0.854346 13.8938 1.7959 13.9893L2 14H8.7386C8.5495 13.7224 8.43013 13.4148 8.3777 13.0996H2C1.39249 13.0996 0.900391 12.6075 0.900391 12V2C0.900391 1.39249 1.39249 0.900391 2 0.900391H12C12.6075 0.900391 13.0996 1.39249 13.0996 2V9.00939C13.1864 9.00315 13.2735 9 13.3609 9H14Z",
    fill: "#1C738E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9848 11.3527L15.1707 14.1494C15.1098 14.3485 14.95 14.4813 14.7598 14.4813H11.6174C11.4348 14.4813 11.2598 14.3568 11.1989 14.1743L9.99674 10.6639H9.30435C9.13696 10.6639 9 10.5145 9 10.332C9 10.1494 9.13696 10 9.30435 10H10.2098C10.3391 10 10.4533 10.0913 10.4989 10.2241L11.7391 13.8174H14.6304L15.2772 11.5768H11.6935C11.5261 11.5768 11.3891 11.4274 11.3891 11.2448C11.3891 11.0622 11.5261 10.9129 11.6935 10.9129H15.6957C15.7946 10.9129 15.8859 10.971 15.9391 11.0539C16 11.1369 16.0152 11.2531 15.9848 11.3527ZM11.7696 14.9212C11.6402 14.9212 11.5109 14.9793 11.4196 15.0788C11.3283 15.1784 11.275 15.3195 11.275 15.4606C11.275 15.6017 11.3283 15.7427 11.4196 15.8423C11.5109 15.9419 11.6402 16 11.7696 16C11.8989 16 12.0283 15.9419 12.1196 15.8423C12.2109 15.7427 12.2641 15.6017 12.2641 15.4606C12.2641 15.3195 12.2109 15.1784 12.1196 15.0788C12.0283 14.9793 11.8989 14.9212 11.7696 14.9212ZM14.5011 14.9212C14.3717 14.9212 14.2424 14.9793 14.1511 15.0788C14.0598 15.1784 14.0065 15.3195 14.0065 15.4606C14.0065 15.6017 14.0598 15.7427 14.1511 15.8423C14.2424 15.9419 14.3717 16 14.5011 16C14.6304 16 14.7598 15.9419 14.8511 15.8423C14.9424 15.7427 14.9957 15.6017 14.9957 15.4606C14.9957 15.3195 14.9424 15.1784 14.8511 15.0788C14.7598 14.9793 14.6304 14.9212 14.5011 14.9212Z",
    fill: "#1C738E",
    stroke: "#1C738E",
    strokeWidth: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/orders.e31aff1c3437a2e6bf9ee5433fa5d1c3.svg";
export { ForwardRef as ReactComponent };